<template>
	<div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
		<div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-6 text-base">
			<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-4xl text-start">Sitemap</div>

			<div class="space-y-4">
				<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-3xl text-start">Pages</div>
				<ul class="list-disc pl-6">
					<li><router-link to="/sms" class="link">Text Updates</router-link></li>
					<li>
						<router-link to="/about" class="link">About</router-link>
						<ul class="list-disc pl-6">
							<li><router-link to="/about-us" class="link">About Us</router-link></li>
							<li><router-link to="/custom-birth-kit-service" class="link">Custom Birth Kit Service</router-link></li>
						</ul>
					</li>
					<li>
						<router-link to="/support" class="link">Support</router-link>
						<ul class="list-disc pl-6">
							<li><router-link to="/shipping-info" class="link">Ordering & Shipping Info</router-link></li>
							<li><router-link to="/help-center" class="link">Help Center</router-link></li>
							<li><router-link to="/returns" class="link">Returns</router-link></li>
							<li><router-link to="/final-sale-items" class="link">Final Sale Items</router-link></li>
							<li><router-link to="/discount-code-terms" class="link">Discount Code Terms</router-link></li>
							<li><router-link to="/gift-certificates" class="link">Gift Certificates</router-link></li>
						</ul>
					</li>
					<li><router-link to="/birth-pool-setup" class="link">Birth Pool Setup and Use Best Practices</router-link></li>
					<li><router-link to="/newman-doppler-trade-in" class="link">Newman Doppler Trade-In Offer</router-link></li>
					<li><router-link to="/" class="link">Home</router-link></li>
				</ul>
			</div>

			<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-3xl text-start">Categories</div>
			<div>
				<ul class="list-disc pl-6">
					<template v-for="category in previewCategories">
						<li class="list-disc">
							<a :href="`/categories${category.url}`" class="link">{{ category.name }}</a>
							<template v-if="category.subCategories.length > 0">
								<ul class="list-disc pl-6">
									<li v-for="subCategory in category.subCategories">
										<a :href="`/categories${subCategory.url}`" class="link">{{ subCategory.name }}</a>
										<template v-if="subCategory.subCategories.length > 0">
											<ul class="list-disc pl-6">
												<li v-for="subCategory in subCategory.subCategories">
													<a :href="`/categories${subCategory.url}`" class="link">{{ subCategory.name }}</a>
												</li>
											</ul>
										</template>
									</li>
								</ul>
							</template>
						</li>
					</template>
					<li><router-link to="/sitemap-categories" class="link">Show All</router-link></li>
				</ul>
			</div>

			<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-3xl text-start">Brands</div>
			<div>
				<ul class="list-disc pl-6">
					<li v-for="brand in previewBrands" :key="brand.name">
						<router-link :to="brand?.hasCategory ? `/categories${brand.url}` : `/brands${brand.url}`" class="link">
							{{ brand.name }}
						</router-link>
					</li>
					<li><router-link to="/sitemap-brands" class="link">Show All</router-link></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Sitemap',
	inject: ['store'],
	data() {
		return {
			previewCategories: [],
			previewCategoryIds: [10, 16, 13],
			previewBrands: [],
		}
	},
	async created() {
		const categories = await axios.get(`${this.store.api}/controllers/bigCommerce/categories?previewCategories=${this.previewCategoryIds.join(',')}`)
		this.previewCategories = categories.data

		const brands = await axios.get(`${this.store.api}/controllers/bigCommerce/brands?preview=true`)
		this.previewBrands = brands.data
			.filter((b) => b.bcId !== 28 && b.bcId !== 23)
			.map((b) => {
				let newUrl = b.url || ''
				if (newUrl.startsWith('/brands')) {
					newUrl = newUrl.replace('/brands', '')
				}
				if (newUrl.endsWith('.html')) {
					newUrl = newUrl.replace('.html', '')
				}
				return { ...b, url: newUrl }
			})
	},
}
</script>

<style scoped>
.link {
	@apply text-ihh-dark-salmon hover:text-ihh-salmon font-semibold underline;
}
</style>
